import { createBrowserRouter, createRoutesFromElements, Route } from "react-router-dom";
import Protected from "./protectedRoutes";
import NonProtected from "./nonProtectedRoutes";
import { RoutingList } from "./list";

// Ensure RoutingList exists
if (!RoutingList || !Array.isArray(RoutingList)) {
  throw new Error("RoutingList must be a valid array");
}

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      {RoutingList.map((route) => (
        <Route
          key={`route-${route.route}`}
          path={route.route}
          element={
            route.is_protected ? (
              <Protected allowedRoles={route?.allowedRoles} >{route.element}</Protected>
            ) : (
              <NonProtected>{route.element}</NonProtected>
            )
          }
        >
          {route.children?.map((child) => (
            <Route
              key={`child-${route.route}-${child.route}`}
              path={child.route}
              element={
                child.is_protected ? (
                  <Protected allowedRoles={child?.allowedRoles}>{child.element}</Protected>
                ) : (
                  <NonProtected>{child.element}</NonProtected>
                )
              }
            />
          ))}
        </Route>
      ))}
    </>
  )
);

export default router;
